import { CpOrderForm } from 'components/secondaryMarket/cpOrder/cpOrderForm';
import { CpOrderFormContent } from 'components/secondaryMarket/cpOrder/cpOrderFormContent';

import { connectCpOrderForm } from './cpOrderForm.connect';
import { connectCpOrderFormContent } from './cpOrderFormContent.connect';

export const ConnectedCpOrderFormContent = connectCpOrderFormContent(CpOrderFormContent);
export const ConnectedCpOrderForm = connectCpOrderForm(CpOrderForm);
